<div class="ui inverted menu header-menu">
  <a class="item mobile-hide osu-logo" href="/">
    <img src="/images/logo.png" alt="osuStuff.org">
  </a>
  <a class="item" [routerLink]="['/']">
    Bounties
  </a>
  <a class="item" [routerLink]="['/stats']">
    Leaderboard / Stats
  </a>
  <a class="item" [routerLink]="['/comments']">
    Comments
  </a>
  <a class="item" [routerLink]="['/support']">
    Help / FAQ
  </a>
  <div class="right menu">
    <a *ngIf="!user" class="item" href="/login">
      <i class="sign in icon"></i>
      Login
    </a>
    <a *ngIf="!user" class="item" href="/register">
      <i class="user plus icon"></i>
      Register
    </a>
    <a *ngIf="user" class="item" [routerLink]="['/user/', user.id]">
      <i class="user icon"></i>
      {{ user.name }}
    </a>
    <a *ngIf="user" class="notifications item" [routerLink]="['/notifications']">
      <i class="bell icon"></i>
      <div class="ui small red floating label" [class.red]="user.unread_notifications.length">
        {{user.unread_notifications.length}}
      </div>
    </a>
    <!-- <a *ngIf="user" class="item mobile-hide" href="/logout" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
      <i class="sign out icon"></i>
      Log out
    </a> -->
    <a class="icon link item" href="https://discord.gg/wFxEaE9">
      <i class="large discord icon"></i>
    </a>
  </div>
</div>
